import './index.css';
import { ViteReactSSG } from 'vite-react-ssg';
import { routes } from './routes';
import reportWebVitals from './reportWebVitals';

export const createRoot = ViteReactSSG(
  { routes },
  ({ isClient }) => {
    if (isClient) {
      reportWebVitals();
      window.addEventListener('vite:preloadError', () => {
        window.location.reload();
      });
    }
  },
);
